import { QK } from '@api/queryKeys';
import {
  AuditorFirmTeamsResponse,
  InviteTeamMemberPayload,
  UpdateTeamPayload,
  UpdateTeamMemberPayload,
  UpdateTeamMemberSignatoryPayload,
} from '@api/types';
import { useMutation, useQuery } from '@tanstack/react-query';
import { teamApi } from './team';

export const useGetTeam = (enabled = true) => {
  return useQuery({
    queryKey: QK.team(),
    queryFn: () => teamApi.getTeam(),
    enabled,
  });
};

export const useAuditorFirms = (enabled = true) => {
  return useQuery<AuditorFirmTeamsResponse>({
    queryKey: QK.teamAuditorFirms(),
    queryFn: () => teamApi.listAuditorFirms(),
    enabled,
  });
};

export const useUpdateTeam = () => {
  return useMutation({
    mutationFn: (data: UpdateTeamPayload) => teamApi.updateTeam(data),
  });
};

export const useInviteUser = () => {
  return useMutation({
    mutationFn: (data: InviteTeamMemberPayload) => teamApi.inviteUser(data),
  });
};

/**
 * The member writes toast a refusal in the server's words ("You can't remove the last admin", a
 * 400): the toast is the only place the caller learns the change did not happen.
 */
const MEMBER_WRITE_TOAST = { showErrorToast: true } as const;

export const useChangeTeamSignatory = () => {
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateTeamMemberSignatoryPayload }) =>
      teamApi.changeTeamSignatory(id, data),
    meta: MEMBER_WRITE_TOAST,
  });
};

export const useUpdateTeamMember = () => {
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateTeamMemberPayload }) =>
      teamApi.updateTeamMember(id, data),
    meta: MEMBER_WRITE_TOAST,
  });
};

export const useRemoveTeamMember = () => {
  return useMutation({
    mutationFn: (id: string) => teamApi.removeTeamMember(id),
    meta: MEMBER_WRITE_TOAST,
  });
};
